import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

interface NoItemsConfig {
  description: string;
  action: string;
  lottieConfig: any;
}

@Component({
  selector: 'app-no-items-card',
  templateUrl: './no-items-card.component.html',
  styleUrls: ['./no-items-card.component.scss']
})
export class NoItemsCardComponent implements OnInit {

  @Input() noItemsConfig;
  @Output() animationCreated = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  public handleAnimation(animation) {
    this.animationCreated.emit(animation);
  }
}
